
/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
// import 'react-dropzone-component/styles/filepicker.css'
import { useEffect, useState } from "react";

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React TS examples components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import { Icon, IconButton, Modal } from "@mui/material";
import { generateQrCode, getUUIDFromKey } from "utils/helpers";
import Alert from "components/Alert";
import { deleteCardCollections, getCardCollections } from "services/card-collection-services";
import { Box } from "@mui/system";
import config from '../../../config'
import { MenuPopover } from "components/MenuPopover";
import { Table } from "types";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "context/app-context";

// interface CardType {
//   PK: string
//   name: string
//   subject: string
//   grade: string
//   isShared: boolean
// }

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'auto',
  maxHeight: 'calc(100vh - 100px)',
  overflowY: 'auto',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

function SavedCards(): JSX.Element {
  const navigate = useNavigate()
  // const [pk, setPk] = useState<string>('')
  const [data, setData] = useState({} as Table)
  // const [card, setCard] = useState({} as CardType)
  const [dataTableData, setDataTableData] = useState<null | Table>(null)
  const [openQrCodeModal, setOpenQrCodeModal] = useState(false)
  // const [openPlayModal, setOpenPlayModal] = useState(false)
  const [url, setUrl] = useState('')
  const [imageUrl, setImageUrl] = useState('')

  useEffect(() => {
    if (url) {
      (async () =>
        await generateQrCode(`${(config.API.address)}/kort/${getUUIDFromKey(url)}`, setImageUrl
        ))()
    }
  }, [url])

  useEffect(() => {
    (async () => {
      setDataTableData({
        columns: [
          { Header: "Handlinger", accessor: "actions", width: "10%" },
          { Header: "titel", accessor: "name", width: "60%" },
          { Header: "Klassetrin", accessor: "grade", width: "10%" },
          { Header: "Fag", accessor: "subject", width: "10%" }], rows: await getCardCollections()
      })
    })()
  }, [])

  // const handleEdit = (card: { [key: string]: any; }) => {
  //   setCard({ ...card, name: card.name, PK: card.PK, grade: card.grade, subject: card.subject, isShared: card.isShared as boolean })
  // }

  const handleQRCode = (pk: string) => {
    setUrl(pk)
    setOpenQrCodeModal(open => !open)
  }

  const handlePlay = (pk: string) => {
    // setPk(pk)
    window.open(`/kort/${getUUIDFromKey(pk)}`,'_blank')
  }

  const handleDelete = (card: { [key: string]: any; }) => {
    warningWithConfirmAndCancelMessage(card.PK)
  }

  useEffect(() => {
    if (dataTableData) {
      setData({
        ...dataTableData, rows: dataTableData.rows.map((dt) => ({
          ...dt,
          actions: (
            <>
              <MenuPopover
                menuEntries={[
                  {
                    icon: 'qr_code_2',
                    text: 'Se Qr-Kode',
                    onClick: () => handleQRCode(dt.PK)
                },
                {
                    icon: 'edit',
                    text: 'Redigér',
                    onClick: () => editGame(dt)
                },
                {
                    icon: 'play_arrow',
                    text: 'Spil med kortet',
                    onClick: () => handlePlay(dt.PK)
                },
                {
                    icon: 'delete',
                    text: 'Slet',
                    onClick: () => handleDelete(dt)
                }
                ]}
              />
            </>
          ),
          // name: dt.name,
          removeLink: (
            <IconButton key={dt.title} onClick={async () => await warningWithConfirmAndCancelMessage(dt.PK)}><Icon fontSize="small">delete</Icon></IconButton>
          )
        })
        )
      })
    }
  }, [dataTableData])


  // useEffect(() => {
  //   if (Object.keys(card).length) {
  //     setPk(card.PK)
  //   }
  // }, [card])

  const { handleMessage } = useAppContext()

  // const handleCreateCategory = async () => {
  //   try {
  //     const PK = await createCategory({
  //       name, subject: subjectValue, grade: gradeValue
  //     })

  //     setDataTableData({
  //       ...dataTableData, rows: [...dataTableData.rows, { PK: `CATEGORY#${PK}`, name, subject: subjectValue, grade: gradeValue }]
  //     })
  //     handleMessage('You have successfully created a category', 'success')
  //   } catch (error) {
  //     //@ts-ignore
  //     handleMessage(error?.response?.data?.message || error?.message, 'error')
  //   }
  // }

  // const handleUpdateCategory = async () => {
  //   try {
  //     const udatedCategory = await updateCategory(getUUIDFromKey(pk), {
  //       name, subject: subjectValue, grade: gradeValue
  //     })

  //     dataTableData.rows.splice(dataTableData.rows.findIndex((dt: any) => dt.PK === pk), 1, udatedCategory)
  //     setDataTableData({
  //       ...dataTableData, rows: [...dataTableData.rows]
  //     })
  //     setPk('')
  //     handleMessage(`You have successfully updated the category ${name}`, 'success')
  //   } catch (error) {
  //     //@ts-ignore
  //     handleMessage(error?.response?.data?.message || error?.message, 'error')
  //   }
  // }
  const handleDeleteCardCollections = async (cardCollectionId: string) => {
    try {
      await deleteCardCollections(getUUIDFromKey(cardCollectionId))
      setDataTableData({
        ...dataTableData, rows: dataTableData.rows.filter(dt => dt.PK !== cardCollectionId)
      })
      success()
    } catch (error) {
      //@ts-ignore
      handleMessage(error?.response?.data?.message || error?.message, 'error')
    }

  }
  const [alert, setAlert] = useState(null)

  const hideAlert = () => {
    setAlert(null);
  };
  const success = (type = 'archive') => {
    setAlert(
      //@ts-ignore
      <Alert
        success
        style={{
          display: 'block',
          marginTop: '-100px',
        }}
        title='Slettet!'
        confirmBtnText='Okay'
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle='success'
        btnSize=''
      > Dit kort blev fjernet...</Alert>
    );
  };
  const cancel = () => {
    setAlert(
      <Alert
        danger
        style={{
          display: 'block',
          marginTop: '-100px',
        }}
        title='Aflyst'
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnText='Okay'
        confirmBtnBsStyle='success'
        btnSize=''
      ></Alert>
    );
  };
  const warningWithConfirmAndCancelMessage = (id: string) => {
    setAlert(
      //@ts-ignore
      <Alert
        warning
        style={{
          display: 'block',
          marginTop: '-100px',
        }}
        title='Er du sikker?'
        onConfirm={async () => {
          await handleDeleteCardCollections(id);
        }}
        onCancel={() => cancel()}
        confirmBtnBsStyle='success'
        cancelBtnBsStyle='danger'
        confirmBtnText='Ja, slet!'
        cancelBtnText='Annullér'
        showCancel
        btnSize=''
      > Er du sikker på, at du vil slette denne kortsamling?
      </Alert>
    );
  };
  // const [session, setSession] = useState<PlaySessionDto['indexes']>({})
  // const [playSessionPk, setPlaySessionPk] = useState<string>('')

  // const startNewGame = async () => {
  //   const newSession = await createUpdatePlaySession(getUUIDFromKey(pk), getUUIDFromKey(playSessionPk), {})
  //   setSession(newSession.indexes)
  //   window.open(`/kort/${getUUIDFromKey(pk)}`,'_blank')
  // }

  const editGame = async (cardCollection: {[key: string]: any}) => { // @ts-ignore
    navigate(`/cards/generator`, { state: { cardCollection } })
  }
  // useEffect(() => {
  //   if (pk) {
  //     (async () => {
  //       const session = await getPlaySessionByCardCollectionId(getUUIDFromKey(pk)) || {} as PlaySessionDto
  //       setSession(session.indexes || {})
  //       if (!Object.keys(session).length) {
  //         Object.assign(session, { PK: `PLAYSESSION#${uuidv4()}` })
  //       }
  //       setPlaySessionPk(session.PK)
  //       setIsLoading(false)
  //     })()
  //   }
  // }, [pk])

  // const keepLastGame = async () => {
  //   if (Object.keys(session).length) {
  //     window.open(`/kort/${getUUIDFromKey(pk)}`,'_blank')
  //   }
  // }
  // const [isLoading, setIsLoading] = useState(true)
  return (
    <DashboardLayout>
      {/* <Modal
        open={openPlayModal}
        onClose={() => {
          setOpenPlayModal(!openPlayModal)
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={style}
          display='flex'
          flexDirection='column'
        >
          <Typography alignSelf='center' variant="h4">Hvad ønsker du?</Typography>
          <MDBox minWidth={315} display='flex' flexWrap='wrap' justifyContent={isLoading ? 'center' : 'space-between'} >
            {isLoading ? <CircularProgress color='info' /> : <>
              <MDButton onClick={startNewGame} color='success'>Start ny runde</MDButton>
              <MDButton onClick={keepLastGame} color='info'>Fortsæt runde</MDButton></>}
          </MDBox>
        </Box>
      </Modal> */}
      <Modal
        open={openQrCodeModal}
        onClose={() => {
          setOpenQrCodeModal(!openQrCodeModal)
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={style}
          display='flex'
          flexDirection='column'
        >
          <img style={{ width: 'calc(100vw - 40px)', maxWidth: 550 }} src={imageUrl} alt='qr code' />
          <a href={`${(config.API.address)}/kort/${getUUIDFromKey(url)}`} style={{
            textAlign: 'center',
            inlineSize: 'calc(100vw - 40px)',
            maxWidth: 550,
            overflowWrap: 'break-word'
          }}>{`${(config.API.address)}/kort/${getUUIDFromKey(url)}`}</a>
        </Box>
      </Modal>
      <DashboardNavbar />
      <MDBox mt={6} mb={3}>
        {alert}
        <Card>
          <MDBox p={3} lineHeight={1}>
            <MDTypography variant="h5" fontWeight="medium">
              Gemte kort
            </MDTypography><br />
            <MDTypography variant="h6">
              Her er en oversigt over dine gemte kort
            </MDTypography>
            <MDTypography variant="h6">
              Klik på ”handlinger” for at spille med kortene
            </MDTypography>
          </MDBox>
          {Object.keys(data).length ? <DataTable table={data} canSearch /> : null}
        </Card>
      </MDBox >
    </DashboardLayout >
  );
}

export default SavedCards;
